import React from 'react';
import { sessionStorage, STORAGE_KEYS } from '../utils/sessionStorage';
import './SessionExpirationModal.css';

interface SessionExpirationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigateToLogin: () => void;
}

/**
 * Modal component that appears when a session expires
 * Provides a clear message and a button to log in again
 */
const SessionExpirationModal: React.FC<SessionExpirationModalProps> = ({ 
  isOpen, 
  onClose,
  onNavigateToLogin
}) => {
  if (!isOpen) return null;
  
  const handleLogin = () => {
    // We want to preserve the current route for restoration after login
    // But we don't want to preserve any other state
    const currentRoute = sessionStorage.getItem(STORAGE_KEYS.ROUTE);
    
    // Clear all session data except the route
    sessionStorage.clearAllAppData();
    
    // Save the route back if it exists
    if (currentRoute) {
      sessionStorage.setItem(STORAGE_KEYS.ROUTE, currentRoute);
    }
    
    onClose();
    onNavigateToLogin();
  };
  
  return (
    <div className="modal-overlay">
      <div className="modal-content" role="dialog" aria-modal="true" aria-labelledby="session-expiration-title">
        <h2 id="session-expiration-title">Session Expired</h2>
        <p>Your session has expired for security reasons. Please log in again to continue.</p>
        <p>Don't worry - we'll remeber where you were and return you there after you log in.</p>
        <div className="modal-actions">
          <button 
            className="button-primary" 
            onClick={handleLogin}
            aria-label="Log in again"
          >
            Log In Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpirationModal;